import React, { useState, useContext, useMemo, useEffect, useRef } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import { DesignContext } from '../../../contexts/DesignContext'
import CustomButton from './Button'
import objectPath from 'object-path'
import Label from './Label'

const ImageCropper = (props) => {
  const designContext = useContext(DesignContext)
  const { jsonForm, setFormData, elementAction } = designContext
  let { uischema, config } = props
  const {
    isDynamic = false,
    dynamicName = '',
    dynamicIndex = 0,
    dynamicData = {},
    onUpdateFormData = () => {},
    isArray,
    arrayName,
  } = config

  const fieldKey = isArray
    ? `@${arrayName}.${uischema.key}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
    : uischema.key
  const fieldName = isArray
    ? `@${arrayName}.${uischema.name}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.name}`
    : uischema.name

  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = objectPath.get(elementAction, ['isEnable', uischema.key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  const initialSrc = ''
  const [image, setImage] = useState(initialSrc)
  const [file, setFile] = useState(null)
  const [cropper, setCropper] = useState()
  const [supportedFile, setSupportedFile] = useState(0)
  const [change, setChange] = useState(null)
  const [disabledCrop, setDisabledCrop] = useState(false)
  const [fileName, setFileName] = useState('')

  const componentKey = useMemo(() => {
    if (uischema.action.name === 'field' && uischema.action.component) {
      return uischema.action.component.key
    }
    return ''
  }, [])

  const supportedFileHandler = (event) => {
    setSupportedFile(!!event.target.value)
  }

  const cropperStyle = {
    height: uischema.height,
    width: '100%',
    backgroundColor: '#f8f9fa',
  }

  const onChangeImage = (e) => {
    e.preventDefault()
    let files = []
    if (e.dataTransfer) {
      files = e.dataTransfer.files
    } else if (e.target) {
      files = e.target.files
    }
    setFile(files[0])
    setFileName(files[0].name)
    const reader = new FileReader()
    reader.onload = () => {
      setImage(reader.result)
    }
    reader.readAsDataURL(files[0])
  }

  const getCropData = async () => {
    if (image && typeof cropper !== 'undefined') {
      let imageCrop = cropper.getCroppedCanvas().toDataURL()
      setImage(imageCrop)
      let fileCrop = await createFile(imageCrop, fileName)
      setFile(fileCrop)
    }
  }

  const createFile = async (imageSrc, fileName) => {
    if (imageSrc) {
      const response = await fetch(imageSrc)
      const blob = await response.blob()
      const extension = blob.type.split('/').pop()
      let newFileName = fileName.split('.')
      newFileName.pop()
      newFileName = newFileName.join('.')
      fileName = `${newFileName}.${extension}`
      let image = new File([blob], fileName, {
        type: blob.type,
      })

      image = Object.assign(image, {
        path: fileName,
      })
      return image
    }
    return {}
  }

  const createImage = (file) => {
    const reader = new FileReader()
    reader.onload = () => {
      setImage(reader.result)
    }
    reader.readAsDataURL(file)
  }

  const resetCrop = () => {
    let files = jsonForm.formData[componentKey]
    if (files && files[0] && files[0].name) {
      setFile(files[0])
      createImage(files[0])
      setDisabledCrop(false)
    } else {
      setFile(files)
      createImage(files)
      setDisabledCrop(false)
    }
  }

  const useImage = () => {
    setImage('')
    let newFormData = jsonForm.formData
    newFormData[uischema.key] = [file]
    setFormData(newFormData)
    setDisabledCrop(true)
  }

  useEffect(() => {
    if (uischema.action && uischema.action.name === 'field') {
      if (!componentKey) return
      let files = jsonForm.formData[componentKey]
      console.log('imageCropper', componentKey, files)
      if (files && files[0] && files[0].name) {
        setFile(files[0])
        setFileName(files[0].name)
        createImage(files[0])
      } else {
        let newFormData = jsonForm.formData
        newFormData[uischema.key] = null
        newFormData[componentKey] = null
        setFormData(newFormData)
        setImage('')
        setFile(null)
        setFileName('')
        if (cropper) {
          cropper.destroy()
        }
      }
    }
  }, [objectPath.get(jsonForm.formData, componentKey)])

  return (
    <Form.Group className="mb-0" controlId={uischema.controlId}>
      {!isReadOnly && (
        <Row className="w-100 m-0">
          <Label {...props} uischema={uischema} />
          {uischema.action && uischema.action.name === 'browse' && (
            <Col className="mt-2" sm="auto">
              <div className="custom-file">
                <Form.Control
                  type="file"
                  className="custom-file-input"
                  id={`${fieldKey}-custom-file-input`}
                  required
                  isInvalid={!supportedFile}
                  isValid={supportedFile}
                  onChange={(event) => {
                    setChange(event)
                    onChangeImage(event)
                    supportedFileHandler(event)
                  }}
                />
                <Form.Label
                  className="custom-file-label"
                  htmlFor="validatedCustomFile"
                >
                  {fileName ? fileName : 'เลือกไฟล์'}
                </Form.Label>
              </div>
            </Col>
          )}
          <Col sm={12} className="mt-2 mb-2">
            <Cropper
              id={`${fieldKey}-cropper`}
              style={cropperStyle}
              initialAspectRatio={1}
              preview=".img-preview"
              src={image}
              viewMode={1}
              guides={true}
              minCropBoxHeight={10}
              minCropBoxWidth={10}
              background={false}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
              onInitialized={(instance) => {
                setCropper(instance)
              }}
            />
          </Col>
          <Col sm={uischema.button.crop.layoutWidth} className="mt-2">
            <CustomButton
              fieldKey={`${fieldKey}-crop`}
              fieldName={`${fieldName}-crop`}
              disabled={disabledCrop}
              uischema={uischema.button.crop}
              onCustomClick={getCropData}
              customClick={true}
            />
          </Col>
          <Col sm={uischema.button.reset.layoutWidth} className="mt-2">
            <CustomButton
              fieldKey={`${fieldKey}-reset`}
              fieldName={`${fieldName}-reset`}
              uischema={uischema.button.reset}
              onCustomClick={resetCrop}
              customClick={true}
            />
          </Col>
          <Col sm={uischema.button.use.layoutWidth} className="mt-2">
            <CustomButton
              fieldKey={`${fieldKey}-use`}
              fieldName={`${fieldName}-use`}
              uischema={uischema.button.use}
              onCustomClick={useImage}
              customClick={true}
            />
          </Col>
        </Row>
      )}
    </Form.Group>
  )
}

export default ImageCropper
